import { Button, TextField } from "@mui/material";
import React from "react";
import { BsX } from "react-icons/bs";

const index = (props: {
  register: any, handleSubmit: any, errors: any, setFormValue: any, formValue: any, handleNext: any, append: any,
  fields: any, remove: any, unRegister: any
}) => {
  const onSubmit = (data: any) => {
    props.setFormValue({
      ...props.formValue,
      ranges: data.ranges,
    });

    props.handleNext();
  };

  const remove = (index: number) => {
    props.unRegister(`ranges.${index}`);
    props.remove(index);
  };

  return <>
    <form id="page2" onSubmit={props.handleSubmit(onSubmit)}>
      {props.fields.map((range: any, index: number) => (
        <div key={range.id} className="drop-shadow-md container px-5 sm:px-0 px-10 rounded-lg">
          <div className="grid grid-cols-4 gap-2 px-5 py-2">
            <div>
              <TextField size="small" fullWidth label="Name" {...props.register(`ranges.${index}.name`)}
                error={props.errors?.ranges?.[index]?.name ? true : false} />
              <p className="text-sm text-red-700">{props.errors?.ranges?.[index]?.name?.message}</p>
            </div>
            <div>
              <TextField size="small" type="number" fullWidth label="Min %" {...props.register(`ranges.${index}.min`)}
                error={props.errors?.ranges?.[index]?.min ? true : false} />
              <p className="text-sm text-red-700">{props.errors?.ranges?.[index]?.min?.message}</p>
            </div>
            <div>
              <TextField size="small" type="number" fullWidth label="Default %" {...props.register(`ranges.${index}.default`)}
                error={props.errors?.ranges?.[index]?.default ? true : false} />
              <p className="text-sm text-red-700">{props.errors?.ranges?.[index]?.default?.message}</p>
            </div>
            <div>
              <TextField size="small" type="number" fullWidth label="Max %" {...props.register(`ranges.${index}.max`)}
                error={props.errors?.ranges?.[index]?.max ? true : false} />
              <p className="text-sm text-red-700">{props.errors?.ranges?.[index]?.max?.message}</p>
            </div>
          </div>
          <span
            className="absolute top-2 right-0 hover:cursor-pointer"
            onClick={() => remove(index)}
          >
            <BsX size="1.5rem" />
          </span>
        </div>
      ))}
    </form>
    <Button onClick={props.append}>Add Range</Button>
  </>;
};

export default index;
